module.exports = __webpack_public_path__ + "static/staff-karrie-58452fabbf7b9c35f788f230658a5736.png";